export type ProjectStatus = 'active' | 'on_hold' | 'completed' | 'cancelled';
export type ProjectPriority = 'low' | 'medium' | 'high' | 'critical';

/** Department codes validated by the backend (DEPTS_VALID). */
export type ProjectDepartment = 'it' | 'digital_marketing' | 'sales' | 'hr';

/** Populated assignee subdocument returned by the list endpoint. */
export interface AssignedUser {
  id?: string;
  _id?: string;
  display_name?: string;
}

export interface Project {
  id: string;
  name: string;
  department: string;
  description?: string;
  client?: string;
  status: ProjectStatus;
  priority: ProjectPriority;
  deadline?: string | null;
  start_date?: string | null;
  end_date?: string | null;
  project_value?: number;
  reference_url?: string;
  /** May be a populated object, a raw id string, or null depending on source. */
  assigned_to?: string | AssignedUser | null;
  assignee_name?: string;
  creator_name?: string;
  created_by?: string;
  created_at?: string;
  /** Server-computed progress counters — read-only. */
  task_count?: number;
  done_count?: number;
}

export interface ProjectsFilters {
  /** Department filter — only honoured by the backend for privileged users. */
  dept?: string;
}

export interface CreateProjectPayload {
  name: string;
  department: string;
  priority: ProjectPriority;
  status: ProjectStatus;
  deadline?: string | null;
  description?: string;
  project_value?: number;
  assigned_to?: string | null;
  reference_url?: string;
}

/** Edit payload — department is intentionally omitted (immutable server-side). */
export type UpdateProjectPayload = Partial<Omit<CreateProjectPayload, 'department'>>;

export interface UserOption {
  id: string;
  display_name: string;
  role: string;
  department?: string;
  username?: string;
}

/** Extract the assignee id regardless of whether it is populated or raw. */
export function getAssignedId(assigned: Project['assigned_to']): string {
  if (!assigned) return '';
  if (typeof assigned === 'string') return assigned;
  return assigned.id ?? assigned._id ?? '';
}
